import { User } from "@auth0/auth0-react";

export function isAdmin(user: User): boolean{
    return !!user?.["https://rivendita.ipaladini/user"]?.admin;
}

export function isASocialAccount(user: User): boolean{
    return !user.sub || !user.sub.startsWith('auth0|');
}